exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Option-module__button-wrapper___2hlc8{display:grid;gap:1em}.Option-module__wrapper___2TPjh{height:175px;width:100%;background-color:hsla(0,0%,100%,.4);border-radius:10px;cursor:pointer;display:flex;justify-content:center;align-items:center;transition:all .2s ease-in-out}.Option-module__wrapper___2TPjh svg{color:#fff;font-size:60px}.Option-module__wrapper___2TPjh.Option-module__playing___wD__h{background-color:#fff}.Option-module__wrapper___2TPjh.Option-module__playing___wD__h svg{color:#1368e5}.Option-module__wrapper___2TPjh.Option-module__played___Xlqpj{background-color:#fff}.Option-module__wrapper___2TPjh.Option-module__played___Xlqpj svg{color:#1368e5}", ""]);

// exports
exports.locals = {
	"button-wrapper": "Option-module__button-wrapper___2hlc8",
	"wrapper": "Option-module__wrapper___2TPjh",
	"playing": "Option-module__playing___wD__h",
	"played": "Option-module__played___Xlqpj"
};